/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseDateFieldReminderType = {
    Once: 'DATE_FIELD_REMINDER_REMIND_ONCE',
    Monthly: 'DATE_FIELD_REMINDER_REMIND_MONTHLY',
    MonthlyOnce: 'DATE_FIELD_REMINDER_REMIND_MONTHLY_ONCE',
    Yearly: 'DATE_FIELD_REMINDER_REMIND_YEARLY',
    YearlyOnce: 'DATE_FIELD_REMINDER_REMIND_YEARLY_ONCE'
} as const;
export type DatabaseDateFieldReminderType = typeof DatabaseDateFieldReminderType[keyof typeof DatabaseDateFieldReminderType];


export function DatabaseDateFieldReminderTypeFromJSON(json: any): DatabaseDateFieldReminderType {
    return DatabaseDateFieldReminderTypeFromJSONTyped(json, false);
}

export function DatabaseDateFieldReminderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseDateFieldReminderType {
    return json as DatabaseDateFieldReminderType;
}

export function DatabaseDateFieldReminderTypeToJSON(value?: DatabaseDateFieldReminderType | null): any {
    return value as any;
}

